import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/homepage.scss';

import arrowButton from '../assets/img/partnerPortal/homepage/arrowButton.png';


function ButtonArrow(props) {

    const [link] = useState(props.link);
    const [buttonName] = useState(props.buttonName);
    const [className] = useState(props.className);
    const [width] = useState(props.width);
    const [target] = useState(props.target);

    return (

        <a href={link} target={target ? target : "_blank"} >
            <div className={"buttonHomepage " +  className}>
                <div className="buttonLetters2 textAllignLeft">
                    {buttonName}
                    <div className="lineBlack mt-1"></div>
                </div>
                <img src={arrowButton}  alt='...' width={width}  />
                
            </div>
        </a>

    )


}

export default withRouter(ButtonArrow);



